import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fog',
  templateUrl: './fog.component.html',
  styleUrls: ['./fog.component.scss']
})
export class FogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
